import { AfterContentInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AbstractBaseDetailsComponent } from '../../../core/component/abstract-base-details-component';
import { ModuleParamGlobConfigService } from '../../../core/service/moduleFieldConfig/module-param-glob-config.service';
import { VendorDetailModal } from '../modal/vendor-detail-modal';
import { VendorModuleParamConfigModel } from '../modal/vendor-module-param-config-model';

@Component({
  selector: 'app-vendor-detail-add-update',
  templateUrl: './vendor-detail-add-update.component.html',
  styleUrls: ['./vendor-detail-add-update.component.css']
})
export class VendorDetailAddUpdateComponent extends AbstractBaseDetailsComponent implements OnInit, AfterContentInit {
  private readonly MODULE_PARAM_CONFIG_KEY: string = 'partyDetails';

  public submitted: boolean = false;
  public formGroupContact: FormGroup;
  @Input()
  public data: VendorDetailModal;

  @Output('onSave')
  public saveCallback: EventEmitter<VendorDetailModal> = new EventEmitter<VendorDetailModal>();

  @Output('onCancel')
  public cancelCallback: EventEmitter<VendorDetailModal> = new EventEmitter<VendorDetailModal>();

  public moduleParams: VendorModuleParamConfigModel;

  constructor(
    private formBuilder: FormBuilder,
    public toaster: ToastrService,
    private moduleParamConfigGlob: ModuleParamGlobConfigService
  ) {
    super(toaster);
  }

  ngOnInit() {
    this.setValidation();
  }

  setValidation() {
    this.formGroupContact = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      designation: [
        '',
        this.moduleParamConfigGlob.isRequired(this.MODULE_PARAM_CONFIG_KEY, 'designation') ? Validators.required : '',
      ],
      phoneNo: [
        '',
        [
          Validators.required,
          this.numberOnlyValidation,
          Validators.pattern('^[0-9]*$'),
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      secondaryPhoneNo: [
        '',
        [this.numberOnlyValidation, Validators.maxLength(11)],
        this.moduleParamConfigGlob.isRequired(this.MODULE_PARAM_CONFIG_KEY, 'secondary_phone')
          ? Validators.required
          : '',
      ],
      email: ['', [Validators.email, Validators.required]],
    });
  }
  get f() {
    return this.formGroupContact.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.formGroupContact.invalid) {
      return;
    }

    this.saveCallback.emit(this.data);
  }

  onCancel() {
    this.cancelCallback.emit(this.data);
  }

  ngAfterContentInit() {
    this.moduleParams = new VendorModuleParamConfigModel(this.moduleParamConfigGlob);
  }
}